/**
 * CoversStrip — IMG-style "Covers" grid on the homepage.
 * Shows archive entries with type === "cover". Hidden when there are none.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { compactCredits } from "../lib/usePageMeta";

export const CoversStrip = () => {
  const [covers, setCovers] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/latest")
      .then((r) => setCovers((r.data || []).filter((w) => w.type === "cover")))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  if (!loaded || covers.length === 0) return null;

  return (
    <section data-testid="covers-strip" className="border-t border-black/10 bg-white py-14 lg:py-20">
      <div className="max-w-[1800px] mx-auto px-6 lg:px-12">
        <div className="mb-8 lg:mb-12 flex items-end justify-between gap-4 flex-wrap">
          <div>
            <p className="label-overline text-zinc-500">Press / 02</p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tighter font-light mt-2 leading-[0.95]">
              Covers<span className="italic text-zinc-500">.</span>
            </h2>
          </div>
          <Link to="/archive?type=cover" data-testid="covers-archive-link" className="label-overline text-zinc-500 hover:text-black transition-colors">
            View the archive +
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-6">
          {covers.slice(0, 5).map((it) => (
            <Link
              key={it.id}
              to={`/news/${it.id}`}
              data-testid={`cover-tile-${it.id}`}
              className="group block focus:outline-none focus:ring-1 focus:ring-black"
            >
              <div className="relative aspect-[3/4] bg-[#F5F5F5] overflow-hidden">
                <img
                  src={it.image_url}
                  alt={`${it.brand}${it.subtitle ? " — " + it.subtitle : ""}`}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.02]"
                />
              </div>
              <div className="mt-3">
                {it.model_name && <p className="font-serif text-lg leading-tight">{it.model_name}</p>}
                <p className="text-[11px] uppercase tracking-widest text-zinc-500 mt-1">
                  {it.brand}{it.subtitle ? ` — ${it.subtitle}` : ""}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoversStrip;
